export const CREATE_EMPLOYEE_REQUEST = 'CREATE_EMPLOYEE_REQUEST';

export const createEmployeeRequest = ( userData ) => ({
    type: CREATE_EMPLOYEE_REQUEST,
    payload: { ...userData },
});
